import { render, staticRenderFns } from "./Affiliations.vue?vue&type=template&id=4b174922&scoped=true&"
import script from "./Affiliations.vue?vue&type=script&lang=js&"
export * from "./Affiliations.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./Affiliations.vue?vue&type=style&index=0&id=4b174922&lang=sass&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4b174922",
  "52173fc2"
  
)

export default component.exports